/**
 * Feature Flags API Service
 *
 * Fetches the per-institute feature-flag map from the backend.
 * Returns a plain object where each key is a feature-flag name
 * and the value indicates whether the flag is enabled for the
 * current institute.
 */

import { ApiResponse } from '../../types/common';
import { axiosInstance } from './axios';

/**
 * GET /v1/feature-flags
 *
 * Returns the full map of feature flags for the authenticated institute.
 * Throws when the server reports a failure.
 */
export const getInstituteFeatureFlags = async (): Promise<Record<string, boolean>> => {
  const response = await axiosInstance.get<ApiResponse<Record<string, boolean>>>(
    '/v1/feature-flags'
  );

  if (!response.data.succeeded) {
    throw new Error(response.data.messages?.[0] || 'Failed to fetch feature flags');
  }

  return response.data.data;
};
